define('collections/template/calendar/template-calendar-day-items',[
    'underscore',
    'backbone',
    'moment',
    'utils',
    //services
    'services/events/calendar-events',
    // collections
    'collections/calendar/day-items'
], function(
    _, Backbone, moment, U,
    //services
    CalendarEvents,
    // collections
    CCalendarDayItems
) {

    /**
     * Subclass used when the items order is persistent.
     */
    var CTemplateCalendarDayItems = CCalendarDayItems.extend({
        initialize: function(models, opt) {
            if (opt) {
                this.dayId = opt.dayId;
            }
        },

        updatePositions: function(options) {
            var colElItems = null;
            var itemDone = [];

            if (Backbone.$(".calendar-items.sortable").length > 0) {
                if (Backbone.$(".calendar-items.sortable").eq(this.dayId).length > 0) {
                colElItems = Backbone.$(".calendar-items.sortable").eq(this.dayId)[0].childNodes;
                itemDone.length = colElItems.length;
                itemDone.fill(0);
                }
            }

            this.each(function(model, index) {

                model.set('dayId', this.dayId);

                if (colElItems) {
                    for (var i = 0; i < colElItems.length; i++) {
                        var el = colElItems[i];
                        var title = Backbone.$('.item-title', el)[0].textContent;
                        var type = Backbone.$('.item-secondary.item-type', el)[0].textContent;

                        if (model.get('type') === 'custom_data' && type === 'custom data' && title.indexOf(model.get('name')) !== -1 && itemDone[i] === 0) {
                            model.set('position', i);
                            itemDone[i] = 1;
                            break;
                        } else if (model.get('name') === title) {
                            model.set('position', i);
                            itemDone[i] = 1;
                            break;
                        }
                    }
                }
            }, this);


        },

    });

    return CTemplateCalendarDayItems;
});

